import React, { useContext } from 'react';
import styled from 'styled-components';
import Chord from './Chord';
import withHarpInstrument from './hocs/withHarpIntrument'
import { SideBarTitle } from './layout/style';
import { Chords } from '../context';
import Sadko from '../service/Sadko';

const List = styled.ul`
    margin: 0;
    padding: 0;
`;

const ListItem = styled.li`
    list-style: none;
    padding-bottom: 16px;
    margin: 0;
`;

const ChordsList = withHarpInstrument(({ instrument, chords, tune }) => {
    return <List>
        {chords.map((chordName, index) => <ListItem key={`chord-${index}`}>
                <Chord
                    name={chordName}
                    instrument={instrument}
                    fireOnRender={false}
                    drone={Sadko.DRONE_NONE}
                    tune={tune}
                />
            </ListItem>
        )}
    </List>
});

export default function UsedChordsList({ tune }) {
    const { state: chords } = useContext(Chords.Context);
    if (!Array.isArray(chords) || chords.length <= 0) {
        return null;
    }

    return <div>
        <SideBarTitle>Аккорды, используемые на странице</SideBarTitle>
        <ChordsList chords={chords} tune={tune}/>
    </div>
}
